import { ENV } from './constants';

import packageJson from '../../package.json';
import settings from '../../settings.json';

import Auth from '@hotmart/oauth-ui';

export class Settings extends Auth {
  constructor(options = {}) {
    super();
    this._options = options;
  }

  refs = {
    environment: this.environment,
    integrationToken: 'hmClubIntegration',
    auth: '__amplify__oauthData',
    token: 'token',
    user: '__amplify__accountData',
    checkToken: '__amplify__checkTokenData',
    productToken: 'productToken'
  };

  /**
   * Version replaced correctly by webpack-auto-inject-version
   * We use this way to prevent injection of entire package
   * file as these plugin handles the versioning for us
   */
  get packageVersion() {
    return packageJson.version;
  }

  get version() {
    return packageJson.version;
  }

  get subpath() {
    return settings.subpath !== '' ? `/${settings.subpath}` : '';
  }

  get tosVersion() {
    return settings.tosVersion;
  }

  get domain() {
    return settings.domain;
  }

  get cookieDomain() {
    return settings.cookieDomain;
  }

  get cookieConfig() {
    return {
      domain: this.cookieDomain,
      path: '/'
    };
  }

  get subdomain() {
    const subdomainIndex = 0;
    const pattern = '.';
    const host = window.location.host;

    return host.split(pattern)[subdomainIndex];
  }

  get refreshToken() {
    return this.auth.refresh_token;
  }

  get url() {
    return settings.api;
  }

  get staticLinks() {
    return settings.staticLinks;
  }

  get transparentScript() {
    return settings.hotpay;
  }

  get firebaseConfig() {
    return settings.firebaseConfig;
  }

  get newrelicConfig() {
    return settings.newrelicConfig;
  }

  get port() {
    return settings.port;
  }

  get faq() {
    return settings.faq;
  }

  get app() {
    return settings.app;
  }

  get staticUrl() {
    return settings.staticUrl;
  }

  get api() {
    const {
      antiPiracy,
      ask,
      backofficePlayer,
      broadcast,
      club,
      hotClub,
      fileClub,
      hotUpload,
      clubSec,
      clubSettings,
      clubUser,
      community,
      content,
      display,
      duplicationWs,
      hotpay,
      live,
      membershipClass,
      notification,
      oauth,
      playerPlatform,
      playerThumbnail,
      salesSettings,
      salesProfiler,
      tos,
      vulcano,
      businessWorkspace,
      testab,
      clubWebSocket
    } = settings.api;

    return {
      antiPiracy: `${antiPiracy}`,
      ask: `${ask}`,
      backofficePlayer: `${backofficePlayer}`,
      broadcast: `${broadcast}`,
      class: `${membershipClass}`,
      club: `${club}`,
      hotClub: `${hotClub}`,
      fileClub: `${fileClub}`,
      hotUpload: `${hotUpload}`,
      clubSec: `${clubSec}`,
      clubSettings: `${clubSettings}`,
      clubUser: `${clubUser}`,
      community: `${community}`,
      content: `${content}`,
      display: `${display}/rest/v1`,
      eligibleProducts: `${display}/rest/v2`,
      duplicationWs: `${duplicationWs}`,
      hotpay: `${hotpay}/hotmart-checkout/api/v1`,
      live: `${live}`,
      notification: `${notification}/rest/v1`,
      oauth: `${oauth}/security/oauth`,
      player: `${content}/v4/player`,
      playerFile: `${content}/v4/player`,
      playerPlatform: `${playerPlatform}/rest/v1`,
      salesSettings: `${salesSettings}`,
      salesProfiler: `${salesProfiler}/rest/v1`,
      thumbnail: `${playerThumbnail}/rest/v1`,
      thumbor: `${hotClub}/rest/v4/thumbor`,
      tos: `${tos}`,
      user: `${clubSec}/rest/v3`,
      userprofile: `${vulcano}/userprofile/rest/v1`,
      marketplace: `${vulcano}/marketplace/rest/v2`,
      businessWorkspace: `${businessWorkspace}/v1`,
      testab: `${testab}/api/1/test`,
      clubWebSocket: `${clubWebSocket}`
    };
  }

  get environment() {
    const { buildEnv = ENV.PRODUCTION } = settings || {};

    return buildEnv;
  }

  get refreshTokenCookie() {
    return this.getRefreshTokenCookie;
  }

  get testabId() {
    return {};
  }

  updateOauthData = (oauthData) => {
    this.auth = oauthData;
  };

  updateCookiesIntegration = (accessToken) => {
    this.updateIntegrationCookies(accessToken);
  };

  updateCheckTokenData = (checkToken) => {
    this.authCheckToken = checkToken;
  };

  saveRefreshTokenCookie = (refreshToken) => {
    this.saveCookieRefreshToken(refreshToken);
  };

  get isLocal() {
    return this.environment === ENV.LOCAL;
  }

  isProduction() {
    return this.environment === ENV.PRODUCTION;
  }
}

export default new Settings();
